// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ResetPass {
  font-weight: 400;
  font-size: 0.8em;
  line-height: 1.6em;
  font-family: "Open Sans", Frutiger, Calibri, "Myriad Pro", Myriad, sans-serif;
  color: #000;
  text-align: center;
  /* Flex container */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-image: url(/assets/img/accueil.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed; /* fix background gradient */
  min-height: 100%; /* fix sticky footer */
  height: 100vh;
  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/
}
#ResetPass .card-login {
  background: rgba(251, 253, 248, 0.68);
  box-shadow: 11px 16px 83px rgba(64, 75, 5, 0.28);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  width: 557px;
  height: 480px;
  border-radius: 22px;
}
#ResetPass .card-login .content {
  max-width: 362px;
  margin: auto;
}
#ResetPass .card-login .bloc-page-title {
  margin-top: 30px;
  text-align: center;
  font-size: "DM Sans";
  font-weight: 700;
  margin-bottom: 20px;
}
#ResetPass .card-login .bloc-page-title .page-title {
  color: #5620e4;
  font-size: 28px;
}
#ResetPass .card-login .bloc-page-title .sub-title {
  font-size: 12px;
  opacity: 0.8;
  letter-spacing: 0.7px;
}
#ResetPass .card-login .bloc-page-title .img-logo {
  height: 69px;
  width: 134px;
}
#ResetPass .bloc-infos-login {
  color: white;
  text-align: left;
}
#ResetPass .bloc-infos-login .title {
  font-size: 5rem;
}
#ResetPass .bloc-infos-login .details {
  font-size: 1.1rem;
  margin-top: 45px;
}
#ResetPass mat-card {
  background-color: rgba(255, 255, 255, 0.5);
}
#ResetPass mat-card .theme-company-logo {
  height: 120px;
  width: 100%;
  background: transparent url("/assets/img/synlogo.png") 50% no-repeat;
}
#ResetPass mat-card .full-width {
  width: 100%;
}
#ResetPass mat-card .error {
  color: crimson;
  margin: 0;
}
#ResetPass .second-eterno-input {
  margin-top: 15px;
}
#ResetPass .bloc-forget-password {
  text-align: center;
  margin-top: 5px;
}
#ResetPass .bloc-forget-password .forget-password {
  color: #2c2b4a;
  text-decoration-line: underline;
  cursor: pointer;
}
#ResetPass .bloc-button-login {
  margin-top: 17px;
}
#ResetPass .bloc-no-account {
  margin-top: 25px;
  font-weight: bold;
  font-family: "DM Sans";
}
#ResetPass .bloc-no-account p {
  font-size: 14px;
  color: #2c2b4a;
}
#ResetPass .bloc-no-account a {
  cursor: pointer;
  color: #5620e4;
  text-decoration-line: underline;
}

.logo-below {
  position: absolute;
  background: transparent url(/assets/img/synlogo.png);
  background-repeat: no-repeat;
  height: 81px;
  width: 100px;
  left: 76%;
  top: 86.25%;
}

.copyright {
  height: 81px;
  width: 100px;
  left: 85%;
  top: 94%;
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/reset-password/reset-password.component.scss"],"names":[],"mappings":"AA6CA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6EAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA,EAAA,4BAAA;EACA,gBAAA,EAAA,sBAAA;EACA,aAAA;EAsDA,0HAAA;AAjGF;AA8CE;EACE,qCAAA;EACA,gDAAA;EACA,mCAAA;UAAA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA5CJ;AA8CI;EACE,gBAAA;EACA,YAAA;AA5CN;AA+CI;EACE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AA7CN;AA+CM;EACE,cAAA;EACA,eAAA;AA7CR;AAgDM;EACE,eAAA;EACA,YAAA;EACA,qBAAA;AA9CR;AAiDM;EACE,YAAA;EACA,YAAA;AA/CR;AAoDE;EACE,YAAA;EACA,gBAAA;AAlDJ;AAoDI;EACE,eAAA;AAlDN;AAqDI;EACE,iBAAA;EACA,gBAAA;AAnDN;AAuDE;EAGE,0CAAA;AAvDJ;AAyDI;EACE,aAAA;EACA,WAAA;EACA,oEAAA;AAvDN;AA0DI;EACE,WAAA;AAxDN;AA2DI;EACE,cAAA;EACA,SAAA;AAzDN;AA6DE;EACE,gBAAA;AA3DJ;AA8DE;EACE,kBAAA;EACA,eAAA;AA5DJ;AA8DI;EACE,cAAA;EACA,+BAAA;EACA,eAAA;AA5DN;AAgEE;EACE,gBAAA;AA9DJ;AAiEE;EACE,gBAAA;EACA,iBAAA;EACA,sBAAA;AA/DJ;AAiEI;EACE,eAAA;EACA,cAAA;AA/DN;AAkEI;EACE,eAAA;EACA,cAAA;EACA,+BAAA;AAhEN;;AAqEA;EACE,kBAAA;EACA,oDAAA;EACA,4BAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAlEF;;AAqEA;EACE,YAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;AAlEF","sourcesContent":["// #ResetPass {\r\n\r\n// \tbackground-color: #ffffff;\r\n// \tfont-weight: 400;\r\n// \tfont-size: .8em;\r\n// \tline-height: 1.6em;\r\n// \tfont-family: 'Open Sans', Frutiger, Calibri, 'Myriad Pro', Myriad, sans-serif;\r\n// \tcolor: #000;\r\n// \ttext-align: center;\r\n// \tbackground-color: #0082C9;\r\n// \tbackground-image: url('/assets/img/background.jpg');\r\n// \tbackground-position: 50% 50%;\r\n// \tbackground-repeat: no-repeat;\r\n// \tbackground-size: cover;\r\n// \tbackground-attachment: fixed; /* fix background gradient */\r\n// \tmin-height: 100%; /* fix sticky footer */\r\n//   height: 100vh;\r\n//   /* Flex container */\r\n//   display: flex;\r\n// \tflex-direction: column;\r\n// \tjustify-content: center;\r\n//   align-items: center;\r\n  \r\n\r\n//   mat-mdc-card {\r\n//     //width: 30%;\r\n//     //margin: 200px auto;\r\n//     background-color: rgba(255, 255, 255, 0.5);\r\n\r\n//     .theme-company-logo {\r\n//       height: 120px;\r\n//       width: 100%;\r\n//       background: transparent url(\"/assets/img/logo.png\") 50% 0 no-repeat;\r\n//     }\r\n\r\n//     .full-width {\r\n//       width: 100%;\r\n//     }\r\n\r\n//     .error {\r\n//       color: crimson;\r\n//     }\r\n//   }\r\n// }\r\n\r\n#ResetPass {\r\n  font-weight: 400;\r\n  font-size: 0.8em;\r\n  line-height: 1.6em;\r\n  font-family: \"Open Sans\", Frutiger, Calibri, \"Myriad Pro\", Myriad, sans-serif;\r\n  color: #000;\r\n  text-align: center;\r\n  /* Flex container */\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-image: url(/assets/img/accueil.png);\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-attachment: fixed; /* fix background gradient */\r\n  min-height: 100%; /* fix sticky footer */\r\n  height: 100vh;\r\n  \r\n\r\n  .card-login {\r\n    background: rgba(251, 253, 248, 0.68);\r\n    box-shadow: 11px 16px 83px rgba(64, 75, 5, 0.28);\r\n    backdrop-filter: blur(10px);\r\n    width: 557px;\r\n    height: 480px;\r\n    border-radius: 22px;\r\n\r\n    .content {\r\n      max-width: 362px;\r\n      margin: auto;\r\n    }\r\n\r\n    .bloc-page-title {\r\n      margin-top: 30px;\r\n      text-align: center;\r\n      font-size: \"DM Sans\";\r\n      font-weight: 700;\r\n      margin-bottom: 20px;\r\n\r\n      .page-title {\r\n        color: #5620e4;\r\n        font-size: 28px;\r\n      }\r\n\r\n      .sub-title {\r\n        font-size: 12px;\r\n        opacity: 0.8;\r\n        letter-spacing: 0.7px;\r\n      }\r\n\r\n      .img-logo{\r\n        height: 69px;\r\n        width: 134px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .bloc-infos-login {\r\n    color: white;\r\n    text-align: left;\r\n\r\n    .title {\r\n      font-size: 5rem;\r\n    }\r\n\r\n    .details {\r\n      font-size: 1.1rem;\r\n      margin-top: 45px;\r\n    }\r\n  }\r\n  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version.*/\r\n  mat-card {\r\n    //width: 30%;\r\n    //margin: 200px auto;\r\n    background-color: rgba(255, 255, 255, 0.5);\r\n\r\n    .theme-company-logo {\r\n      height: 120px;\r\n      width: 100%;\r\n      background: transparent url(\"/assets/img/synlogo.png\") 50% no-repeat;\r\n    }\r\n\r\n    .full-width {\r\n      width: 100%;\r\n    }\r\n\r\n    .error {\r\n      color: crimson;\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  .second-eterno-input {\r\n    margin-top: 15px;\r\n  }\r\n\r\n  .bloc-forget-password {\r\n    text-align: center;\r\n    margin-top: 5px;\r\n\r\n    .forget-password {\r\n      color: #2c2b4a;\r\n      text-decoration-line: underline;\r\n      cursor: pointer;\r\n    }\r\n  }\r\n\r\n  .bloc-button-login {\r\n    margin-top: 17px;\r\n  }\r\n\r\n  .bloc-no-account {\r\n    margin-top: 25px;\r\n    font-weight: bold;\r\n    font-family: \"DM Sans\";\r\n\r\n    p {\r\n      font-size: 14px;\r\n      color: #2c2b4a;\r\n    }\r\n\r\n    a {\r\n      cursor: pointer;\r\n      color: #5620e4;\r\n      text-decoration-line: underline;\r\n    }\r\n  }\r\n}\r\n\r\n.logo-below {\r\n  position: absolute;\r\n  background: transparent url(/assets/img/synlogo.png);\r\n  background-repeat: no-repeat;\r\n  height: 81px;\r\n  width: 100px;\r\n  left: 76%;\r\n  top: 86.25%;\r\n}\r\n\r\n.copyright {\r\n  height: 81px;\r\n  width: 100px;\r\n  left: 85%;\r\n  top: 94%;\r\n  position: absolute;  ;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
